<template>
  <path d="M14 2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1L0 9v7a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V9l-4-7zM5.732 3h6.535l2.857 5h-3.625a.5.5 0 0 0-.5.5v.411c0 1.044-.761 1.978-1.8 2.079A2.003 2.003 0 0 1 6.999 9v-.5a.5.5 0 0 0-.5-.5H2.874l2.857-5zM16 14.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V10h3.131c.445 1.724 2.006 3 3.869 3s3.424-1.276 3.869-3H16v4.5z"/>
</template>

<script>
export default {
  name: 'my-icon'
}
</script>